import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import MusicPlayer from "../components/MusicPlayer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";

const API_URL = "https://haaterkaj-backend-1.onrender.com";

// ✅ Safe image resolver (Cloudinary + old uploads)
const resolveImage = (image) =>
  image?.startsWith("http") ? image : `${API_URL}${image}`;

export default function Home() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/seller/admin-products`)
      .then((res) => setProducts(res.data.products || res.data))
      .catch((err) => console.log(err));
  }, []);

  const slides = [
    {
      img: "./images/banner.jpg",
      text: "রঙের মেলা, সংস্কৃতির ছোঁয়া",
      sub: "Traditional Bengal Craft & Culture",
    },
    {
      img: "./images/banner2.jpg",
      text: "Handloom Treasures of Bengal",
      sub: "Each piece crafted with love",
    },
    {
      img: "./images/banner3.jpg",
      text: "Clay, Color & Creativity",
      sub: "Art that speaks heritage",
    },
  ];

  const reviews = [
    {
      text: "Owning one of these feels like holding a piece of Bengali soul.",
      author: "— Visitor from Kolkata",
    },
    {
      text: "My grandmother had one like this. It brought tears to my eyes.",
      author: "— Student from Shantiniketan",
    },
    {
      text: "We don't sell art. We share heritage.",
      author: "— Artisan from Bishnupur",
    },
  ];

  return (
    <>
      <div className="alpona-bg"></div>

      <div className="relative font-serif">
        {/* HERO */}
        <section className="h-[70vh]">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            pagination={{ clickable: true }}
            navigation
          >
            {slides.map((slide, i) => (
              <SwiperSlide key={i}>
                <div
                  className="h-[70vh] bg-cover bg-center flex items-center justify-center"
                  style={{ backgroundImage: `url(${slide.img})` }}
                >
                  <div className="bg-black bg-opacity-50 p-8 rounded-lg text-center text-white">
                    <h1 className="text-4xl font-bold mb-4">{slide.text}</h1>
                    <p className="text-lg">{slide.sub}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        {/* PRODUCTS */}
        <section className="p-12 text-center">
          <h2 className="text-5xl font-extrabold mb-4 text-amber-700">
            Our Cultural Showcase
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7 max-w-6xl mx-auto">
            {products.map((item) => (
              <motion.div
                key={item._id}
                whileHover={{ scale: 1.05 }}
                onClick={() => setSelectedProduct(item)}
                className="cursor-pointer rounded-2xl overflow-hidden shadow-xl bg-[#fff0d9] border-4 border-amber-300"
              >
                <img
                  src={resolveImage(item.image)}
                  alt={item.name}
                  className="h-48 w-full object-cover"
                />

                <div className="p-5">
                  <h3 className="font-bold text-amber-800">{item.name}</h3>
                  <p className="text-sm text-gray-600 italic">
                    Handcrafted in {item.place}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

       {/* REVIEWS */}
<section className="py-16 bg-transparent">
  <h2 className="text-4xl font-bold text-center text-amber-800 mb-12">
    Voices of Bengal
  </h2>

  <Swiper
    modules={[Autoplay, Pagination]}
    spaceBetween={30}
    autoplay={{
      delay: 3000,
      disableOnInteraction: false,
    }}
    pagination={{ clickable: true }}
    slidesPerView={1}
    breakpoints={{
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    }}
    className="max-w-6xl mx-auto px-4"
  >
    {reviews.map((r, i) => (
      <SwiperSlide key={i}>
        <div className="p-6 bg-amber-50 rounded-2xl shadow-lg text-center h-full">
          <p className="italic text-gray-700">“{r.text}”</p>
          <p className="mt-4 font-semibold text-amber-800">
            {r.author}
          </p>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</section>


        {/* MODAL */}
        {selectedProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl max-w-lg w-full overflow-hidden">
              <img
                src={resolveImage(selectedProduct.image)}
                alt={selectedProduct.name}
                className="h-64 w-full object-cover"
              />

              <div className="p-6">
                <h2 className="text-2xl font-bold text-amber-800">
                  {selectedProduct.name}
                </h2>
                <p className="mt-3">{selectedProduct.description}</p>

                <ul className="list-disc list-inside mt-4">
                  {selectedProduct.features?.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>

                <button
                  onClick={() => setSelectedProduct(null)}
                  className="mt-5 bg-amber-600 text-white px-4 py-2 rounded w-full"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <MusicPlayer />
      </div>
    </>
  );
}
